import React from "react";
import SettingsCard from "../../Components/SettingsCard/SettingsCard";
import SectionHeader from "../../Components/SectionHeader/SectionHeader";
import { useNavigate } from "react-router";
import Card from "../../../../components/Card";

const Index = () => {
  console.log("Index component rendering");

  const sections = {
    AccessControl: {
      items: [
        {
          icon: "accessControl",
          title: "Roles",
          description:
            "Allows Super Admin to manage staff roles and permissions for secure and efficient access control",
          fill: "#FF6A55",
          path: "/settingsDashboard/accessControl/roles",
        },
        {
          icon: "accessControl",
          title: "Mobile Application",
          description:
            "Control user visibility & access to features & actions in the app",
          fill: "#FF6A55",
          path: "/settingsDashboard/accessControl/mobileApplication",
        },
      ],
      colorClass: "title-red",
    },
  
  };

  const navigate = useNavigate();
  return (
    <>
      <Card>
        {Object.entries(sections).map(([sectionName, { items, colorClass }]) => (
          <div key={sectionName}>
            <SectionHeader title={sectionName} colorClass={colorClass} />
            <div
              className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1 gap-10"
              style={{ width: "65%", marginBottom: "10px" }}
            >
              {items.map((item) => (
                <SettingsCard
                  key={item.title}
                  icon={item.icon}
                  title={item.title}
                  description={item.description}
                  className={item.className}
                  onClick={() => navigate(item.path)}
                  fill={item.fill}
                />
              ))}
            </div>
          </div>
        ))}
      </Card>
    </>
  );
};

export default Index;